// React
import React from "react";

/// Redux
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// Material
import Switch from '@material-ui/core/Switch';
import SwitchAccount from "./switchAccount/switchAccount";
import { Dialog, DialogContent, Slide, Tooltip, useTheme, Button, Menu, MenuItem, Link } from "@material-ui/core";
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import CheckIcon from '@material-ui/icons/Check';
import { FormattedMessage, useIntl } from "react-intl";
import Typography from '@material-ui/core/Typography';
import { useEffect, useRef, useState, useCallback } from "react";
import FieldSkeleton from "../../../components/skeleton/FieldSkeleton";
import * as actions from '../../../store/actions/actions';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Alert from '@material-ui/lab/Alert';
import SmartphoneIcon from '@material-ui/icons/Smartphone';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import VpnKeyOutlinedIcon from '@material-ui/icons/VpnKeyOutlined';
import TextsmsOutlinedIcon from '@material-ui/icons/TextsmsOutlined';
import MoreVertOutlinedIcon from '@material-ui/icons/MoreVertOutlined';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import Edit from '@material-ui/icons/Edit';
import Close from '@material-ui/icons/Close';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import passkeyImg from "../../../utils/images/passkey.svg";
import {flags, configs, external_links} from "../../../feature_flags";
import { isSocialUser, isTIDUser, isEnterpriseFederatedUser } from "../../../utils";
import SignInAndSecurity from "./signInAndSecurity/signInAndSecurity";
// Modus Icons font for single-MFA alert warning icon
import '@trimble-oss/modus-icons/dist/modus-solid/fonts/modus-icons.css';

const Transition = React.forwardRef(function Transition(props, ref) {
     return <Slide direction="left" ref={ref} {...props} />;
});

const PhoneMFAInfo = (props) => {
     return (
          <>
               {props.phoneNumber}
               <div className="notes">
                    <FormattedMessage defaultMessage="To change your preferred MFA method to use an Authenticator Application, you must first disable MFA. Then enable using your Multi-Factor Authenticator Application." />

               </div>
               <div className="notes">
                    <FormattedMessage defaultMessage="This information will be kept private and used only as a second layer of security for your account." />
               </div>
          </>
     )
}

const TOTPMFAInfo = (props) => {
     var totp_reset_end_date = configs.totp_reset_end_date;
     return (
          <>
               <div className="email-holder">
                    <Typography variant="subtitle2">
                         <FormattedMessage defaultMessage="Multi-Factor Authentication Application" />
                    </Typography>
               </div>
               {flags.show_reset_totp &&
               <div className="prompt-info">
                    <InfoOutlined  />
                    <div>
                         <div className="prompt-text">
                              <FormattedMessage defaultMessage="To keep your account safe and updated with the latest features, you will be required to reset your authenticator app connection by {date}." values={{
                              date: totp_reset_end_date
                         }}/>
                         <div className="totp-link" onClick={() => {props.openFrame(props.endpoints.enableTotpMfa)}}>
                             <FormattedMessage defaultMessage="Reset your authenticator app"/>
                         </div>
                         </div>
                    </div>
               </div>}
               <div className="notes">
                    <FormattedMessage defaultMessage="To change your preferred MFA method, you must first disable MFA." />
               </div>
          </>
     )
}

const MFAAction = (props) => {
     const [open, setOpen] = useState(false);
     const [anchorEl, setAnchorEl] = useState(null);

     const handleClick = (event) => {
       setAnchorEl(event.currentTarget);
       setOpen(true);
     };
   
     const handleClose = () => {
       setAnchorEl(null);
       setOpen(false);
     };
     const openDialog = (props,action) => {
          var mfa_type = props.mfa_type;
          handleClose();
          if(action === "disable")
               props.openFrame(mfa_type === "SOFTWARE_TOKEN_MFA" ? 
               props.endpoints.disableTotpMfa : mfa_type === "SMS_MFA" ? 
               props.endpoints.disableSmsMfa : mfa_type === "EMAIL_MFA" ? props.endpoints.disableEmailMfa : props.endpoints.disablePasskeyMfa , "disable");
          else if(action === "enable"){
               if(mfa_type === "PASSKEY_MFA_CREATE"){
                    const redirect_url = props.getFrameUrl(props.endpoints.createPasskey,mfa_type);
                    window.location.replace(redirect_url);
               }else
                    props.openFrame(mfa_type === "SOFTWARE_TOKEN_MFA" ? 
                    props.endpoints.enableTotpMfa : mfa_type === "SMS_MFA" ? 
                    props.endpoints.enableSmsMfa :  mfa_type === "EMAIL_MFA" ? 
                    props.endpoints.enableEmailMfa : mfa_type === "RECOVERY_CODE" ? 
                    props.endpoints.recoveryCodeMfa : props.endpoints.enablePasskeyMfa); 
          }else {
               var post_data = {
                    "mfa_type" : mfa_type
               }
               props.saveIdentityDetails(post_data);
          }
     }
     var set_default_for_sms = props.mfa_type === "SMS_MFA" ? !props.reset_sms_end_date_crossed : true;
     return (
          <>
                  {props.mfa_config[props.mfa_type] ?
                  <>
                    <Button className="custom-button custom-button__focus mfa-menu-icon" onClick={handleClick} disableRipple>
                         <MoreVertOutlinedIcon />
                    </Button>
                  
                    { /*custom popup.opens and close on clicking menu icon
                   { open &&
                   <div className="mfa-action-list" >
                    {props.mfa_config[props.mfa_type] && !props.mfa_config[props.mfa_type].is_default &&
                         <div className="mfa-action-list-item">Make Default</div>
                    }
                         <div className="mfa-action-list-item">Remove</div>
                   </div>
                    }
                    */}

                    {/*MUI popover*/}
                    <Menu 
                    className="mfa-action-pop" 
                    open={open} 
                    anchorEl={anchorEl} 
                    onClose={handleClose}
                    MenuListProps={{ disablePadding: true }}
                    >
                         {(props.mfa_config[props.mfa_type] &&
                         !props.mfa_config[props.mfa_type].is_default) &&
                         set_default_for_sms && (
                              <MenuItem
                              className="mfa-action-pop-item"
                              onClick={() => openDialog(props,"default")}
                              >
                                   <FormattedMessage defaultMessage="Make Default"/>
                              </MenuItem>
                         )}
                         <MenuItem
                         className="mfa-action-pop-item"
                         onClick={() => openDialog(props,"disable")}
                         >
                              <FormattedMessage defaultMessage="Remove"/>
                         </MenuItem>
                    </Menu>    
                    </>
                    : props.mfa_type === 'RECOVERY_CODE' ? 
                    <Button className="list-view-action custom-button buttonLink custom-button__focus" onClick={() => openDialog(props,"enable")} disableRipple> 
                         <FormattedMessage defaultMessage="View"/>
                    </Button> 
                    :
                    <Button className="list-view-action custom-button buttonLink custom-button__focus" onClick={() => openDialog(props,"enable")} disableRipple> 
                         <FormattedMessage defaultMessage="Set up"/>
                    </Button>
                    }       
               
          </>
     )
}
const MFAConfig = (props) => {
     var mfa_config = props.mfaConfig && props.mfaConfig.configured_mfa_settings ? props.mfaConfig.configured_mfa_settings : {};
     var passkey_config = props.passkeyConfig;
     var is_backup_code_enabled = props.mfaConfig && props.mfaConfig.hasOwnProperty("backup_codes")
     var backup_code_config = is_backup_code_enabled ? props.mfaConfig.backup_codes : undefined;



     return (
          <>
               <div className="list-view-switch">
                    <h4><FormattedMessage defaultMessage="Multi-Factor Authentication" />  </h4>
                    {mfa_config && Object.keys(mfa_config).length > 0 ?
                    <h4 ><FormattedMessage defaultMessage="Enabled"/> <Switch color="primary" checked={true}  onClick={() => {props.openFrame(props.endpoints.disableAllMfa) }} disableRipple /></h4>
                    :
                    <h4 ><FormattedMessage defaultMessage="Not Enabled"/></h4>
                    }
               </div>
                    
               <div><FormattedMessage defaultMessage="Keep your Trimble ID secure by adding an extra layer of protection. When you have MFA enabled, you’ll be asked to input a security code from any of the methods below to sign in."/></div>
              
               <div className="list-view-section">
               {props.hasIdentity ?
               <>
             {/*===========PASSKEY============*/}
               <div className="list-view">
                   {mfa_config["PASSKEY_MFA"] ?
                    <>
                         <div className="each-list-view">
                         <CheckCircleOutlinedIcon className="list-view-icon-enabled"/>
                    <div>
                         <div className="list-view-title"> <FormattedMessage defaultMessage="Passkey"/>
                         {mfa_config["PASSKEY_MFA"] && mfa_config["PASSKEY_MFA"].is_default && <span className="custom-badge"><FormattedMessage defaultMessage="Default"/></span>}
                         </div>
                         <div><FormattedMessage defaultMessage="Fingerprint, facial recognition, PIN, and more."/></div>
                    </div>
                    </div>
                     <MFAAction 
                     mfa_config={mfa_config}
                     mfa_type = "PASSKEY_MFA"
                     endpoints= {props.endpoints}
                     openFrame={props.openFrame}
                     saveIdentityDetails={props.saveIdentityDetails}
                     getFrameUrl = {props.getFrameUrl}
                    />
                    </>
                     :
                    /*Hiding passkey enable option if flag is OFF*/
                    (flags.show_passkey_as_mfa &&
                    <>
                     <div className="each-list-view">
                    <img src={passkeyImg} className="passkey-icon-disabled" alt="passkey" width="21" height="21"/>
                         
                    <div>
                         {/*Check if passkey is enabled as first factor*/}
                         {(passkey_config && passkey_config.length > 0) ? 
                              <div className="list-view-title"> <FormattedMessage defaultMessage="Use your existing passkey"/>
                              </div>
                              :
                              <div className="list-view-title"> <FormattedMessage defaultMessage="Passkey"/>
                              </div>
                         }
                         <div><FormattedMessage defaultMessage="Fingerprint, facial recognition, PIN, and more."/></div>
                    
                    </div>
                    </div>
                    <MFAAction 
                    mfa_config={mfa_config}
                    mfa_type = {passkey_config && passkey_config.length > 0 ? "PASSKEY_MFA" : "PASSKEY_MFA_CREATE"}
                    endpoints= {props.endpoints}
                    openFrame={props.openFrame}
                    saveIdentityDetails={props.saveIdentityDetails}
                    getFrameUrl = {props.getFrameUrl}
             
                    />
                    </>)
                    }
              </div>
              
               {/*=============TOTP===========*/}
               <div className="list-view">
                    <div className="each-list-view">
                         {mfa_config["SOFTWARE_TOKEN_MFA"] ? 
                         <CheckCircleOutlinedIcon className="list-view-icon-enabled"/>
                         :<SmartphoneIcon className="list-view-icon"/>
                         }  
                         <div>
                              <div className="list-view-title"> <FormattedMessage defaultMessage="Authenticator App"/> 
                              {mfa_config["SOFTWARE_TOKEN_MFA"] && mfa_config["SOFTWARE_TOKEN_MFA"].is_default && <span className="custom-badge"><FormattedMessage defaultMessage="Default"/></span>}
                              </div>
                              {mfa_config["SOFTWARE_TOKEN_MFA"] ?
                              <div><FormattedMessage defaultMessage="Your authenticator app has been connected."/></div>
                              :<div><FormattedMessage defaultMessage="Get a code from an authenticator app like Google Authenticator."/></div>
                              }
                         </div>
                    </div>
               
                    <MFAAction 
                    mfa_config={mfa_config}
                    mfa_type = "SOFTWARE_TOKEN_MFA"
                    endpoints= {props.endpoints}
                    openFrame={props.openFrame}
                    saveIdentityDetails={props.saveIdentityDetails}
                    getFrameUrl = {props.getFrameUrl}
               
                    />                     
                  
              </div>
               {/*================EMAIl============*/}
              <div className="list-view">
                    <div className="each-list-view">
                         {mfa_config["EMAIL_MFA"] ? 
                         <CheckCircleOutlinedIcon className="list-view-icon-enabled"/>
                         :<MailOutlineIcon className="list-view-icon"/>
                         }
                         <div>
                              <div className="list-view-title"> <FormattedMessage defaultMessage="Secondary Email"/>
                              {mfa_config["EMAIL_MFA"] && mfa_config["EMAIL_MFA"].is_default && <span className="custom-badge"><FormattedMessage defaultMessage="Default"/></span>}
                              </div>
                              {mfa_config["EMAIL_MFA"] && mfa_config["EMAIL_MFA"].destination ?
                              <div>{mfa_config["EMAIL_MFA"].destination}</div>
                              :<div><FormattedMessage defaultMessage="Get a code sent to another email."/></div>
                               }
                         </div>
                    </div>
                    <MFAAction 
                    mfa_config={mfa_config}
                    mfa_type = "EMAIL_MFA"
                    endpoints= {props.endpoints}
                    openFrame={props.openFrame}
                    saveIdentityDetails={props.saveIdentityDetails}
                    getFrameUrl = {props.getFrameUrl}
             
                    />
                     
              </div>

              {/*================BACKUP CODE============*/}
              
                
               <div className="list-view">
                    { 
                         flags.show_recovery_codes && backup_code_config? 
                         <>
                              <div className="each-list-view">
                                   <VpnKeyOutlinedIcon className="list-view-icon"/>
                                   <div>
                                        <div className="list-view-title"> <FormattedMessage defaultMessage="Recovery Code"/>
                                        </div>
                                        {backup_code_config.unused_code_length > 0 ? 
                                        (<div className="my-1">
                                             <FormattedMessage defaultMessage="You have {unused_length} unused recovery codes. Store them in a safe place. If you lose access to your other sign-in methods, you can use a recovery code to access your account."
                                             values={{ unused_length: '' + backup_code_config.unused_code_length }}/>
                                        </div>) : 
                                        (<div className="my-1">
                                             <FormattedMessage defaultMessage="All recovery codes have been used. Generate a new set to ensure continued access to your account." />
                                             </div>) 
                                        }
                                        
                                        {
                                             backup_code_config.download_alert &&
                                             <div className="d-flex">
                                             <Alert icon={<InfoOutlined />} variant="outlined" severity="warning">
                                                  <FormattedMessage defaultMessage="You haven't saved your recovery codes in over a year. To ensure you can always access your account, view and download your current codes." />
                                             </Alert>
                                        </div>
                                        }
                                        
                                             
                                   </div>
                              </div>
                              <MFAAction 
                              mfa_config={mfa_config}
                              mfa_type = "RECOVERY_CODE"
                              endpoints= {props.endpoints}
                              openFrame={props.openFrame}
                              saveIdentityDetails={props.saveIdentityDetails}
                              getFrameUrl = {props.getFrameUrl}
                    
                              />
                         </>
                         :
                         <>
                         </>
                    }
              </div>

               {/*==========Showing SMS MFA option only for existing users who has SMS MFA enabled===============*/ 
               <>
              <div className="list-view">
               {mfa_config["SMS_MFA"]?
               <>
                    <div className="each-list-view">
                         {mfa_config["SMS_MFA"] ? 
                         <CheckCircleOutlinedIcon className="list-view-icon-enabled"/>
                         :<TextsmsOutlinedIcon className="list-view-icon"/>
                         }
                         <div>
                              <div className="list-view-title"> <FormattedMessage defaultMessage="SMS Phone Number"/>
                              {mfa_config["SMS_MFA"] && mfa_config["SMS_MFA"].is_default && <span className="custom-badge"><FormattedMessage defaultMessage="Default"/></span>}
                              </div>
                              {mfa_config["SMS_MFA"] && mfa_config["SMS_MFA"].destination ?
                              <div>{mfa_config["SMS_MFA"].destination.substr(1)}</div>
                              :
                              <div><FormattedMessage defaultMessage="Get a code texted to your phone."/></div>
                              }
                         </div>
                    </div>
                    <MFAAction 
                    mfa_config={mfa_config}
                    mfa_type = "SMS_MFA"
                    endpoints= {props.endpoints}
                    openFrame={props.openFrame}
                    saveIdentityDetails={props.saveIdentityDetails}
                    getFrameUrl = {props.getFrameUrl}
                    reset_sms_end_date_crossed = {props.reset_sms_end_date_crossed}
          
                    />
               </>
               :
               <>
                   {/* <div className="each-list-view">
                         <TextsmsOutlinedIcon className="list-view-icon"/>
                         <div>
                              <div className="list-view-title"> <FormattedMessage defaultMessage="SMS Phone Number"/></div>
                              <div><FormattedMessage defaultMessage="Get a code texted to your phone."/></div>
                         </div>
                    </div>
                    <MFAAction 
                    mfa_config={mfa_config}
                    mfa_type = "SMS_MFA"
                    endpoints= {props.endpoints}
                    openFrame={props.openFrame}
                    saveIdentityDetails={props.saveIdentityDetails}
                    reset_sms_end_date_crossed = {props.reset_sms_end_date_crossed}
          
                    />*/}
               </>
               }
              </div>

           
              {mfa_config["SMS_MFA"] && flags.show_reset_sms &&
                    <div className="prompt-info">
                         <InfoOutlined  />
                         <div>
                              <div className="prompt-text">
                                   <FormattedMessage defaultMessage="SMS verification will no longer be available as a multi-factor authentication (MFA) method after {date}. To keep your account secure, we recommend configuring another default MFA method by {date}." values={{
                                   date: configs.sms_mfa_end_date
                              }}/>

                              </div>
                         </div>
                    </div>}
               </>
                   
          }
              </>
              :<FieldSkeleton/>
          }

             </div>
             

          </>
     )
}
const MFAInfo = (props) => {
     return (<>
          <div className="notes">
               <FormattedMessage defaultMessage="When enabled, you will be asked to sign in with your password and a unique verification code based on the preferred MFA Authentication method associated with your account." />
          </div>

          {
               props.isMfaExists && (<div className="mfa-methods">
                    <h4><FormattedMessage defaultMessage="Preferred Method" /></h4>
                    {
                         props.mfaMethodType === "SOFTWARE_TOKEN_MFA" && <TOTPMFAInfo {...props} />
                    }

                    {
                         props.mfaMethodType === "SMS_MFA" && <PhoneMFAInfo {...props} />
                    }
               </div>)
               }
            
              
     </>);
}
const PasskeyConfig = (props) => {
     var passkey_config = props.passkeyConfig;
     const getLocaleTime = (time) => {
          var myDate = new Date(time*1000);
          return myDate.toLocaleDateString('en-us', {year:"numeric", month:"short", day:"numeric"});
     }
     var create_passkey_endpoint =  props.endpoints.createPasskey;
     var manage_passkey_endpoint =  props.endpoints.managePasskey;

     const redirect_url = props.getFrameUrl(create_passkey_endpoint);
     return(
          <>
           <div className="list-view-switch">
                    <h4><FormattedMessage defaultMessage="Manage passkeys"/>  </h4>
                    {passkey_config && passkey_config.length === 3 ?
                    <div><FormattedMessage defaultMessage="Max of 3 passkeys"/> </div>
                    :
                    <>
                    <a href={redirect_url} className="link-button" target="_self"><FormattedMessage defaultMessage="Create a passkey"/></a>
                    </>
                    }
               </div>
               {props.hasIdentity ?
               <>
               {passkey_config && passkey_config.length > 0?
               <div className="list-view-section">
                   
                         {passkey_config.map((passkey,i) => 
                          <div key={i} className="list-view">
                                   <div className="each-list-view">
                                         <img src={passkeyImg} className="passkey-icon-static" alt="passkey" width="21" height="21"/>
                                        <div>
                                             <div className="list-view-title">{passkey.passkey_name}</div>
                                             <div className="passkey-time"><span><FormattedMessage defaultMessage="Created:"/></span> {getLocaleTime(passkey.created_time)}</div>
                                             <div className="passkey-time"><span><FormattedMessage defaultMessage="Last used:"/></span> {getLocaleTime(passkey.last_used_time)}</div>
                                        </div>
                                   </div>
                                   <div className="passkey-action">
                                        <Tooltip
                                             title={<div style={{ fontSize:"12px",padding:"2px" }}>Edit name</div>}
                                             arrow
                                             placement="top"
                                        >
                                             <Button
                                             className="custom-button passkey-icon custom-button__focus"
                                             aria-label="Edit passkey"
                                             onClick={() => {
                                             props.openFrame(
                                                  manage_passkey_endpoint,
                                                  "edit_passkey",
                                                  window.btoa(Array.from(new TextEncoder().encode(JSON.stringify(passkey)), byte => String.fromCharCode(byte)).join('')));
                                             }}
                                             disableRipple
                                             >
                                                  <Edit />
                                             </Button>
                                        </Tooltip>
                                        <Tooltip
                                             title={<div style={{ fontSize:"12px",padding:"2px" }}>Remove</div>}
                                             arrow
                                             placement="top"
                                        >
                                             <Button
                                             className="custom-button passkey-icon custom-button__focus"
                                             aria-label="Remove passkey"
                                             onClick={() => {
                                             props.openFrame(
                                                  manage_passkey_endpoint,
                                                  "delete_passkey",
                                                  window.btoa(Array.from(new TextEncoder().encode(JSON.stringify(passkey)), byte => String.fromCharCode(byte)).join('')));
                                             }}
                                             disableRipple
                                             >
                                                  <Close />
                                             </Button>
                                        </Tooltip>
                                   </div>
                         </div>
                         )}                                   
               </div>
               :    
               <div>
                    <FormattedMessage 
                              defaultMessage="Sign in faster and more securely with passkeys. Passkeys replace passwords with your fingerprint, face ID, or device screen lock, making sign in simple and safe. {url}" 
                              values={
                                   {
                                        url: <Link className="inherit-text custom-button__focus" target="_blank"
                                        rel="noopener noreferrer" href={external_links.passkey_learn_more}> <FormattedMessage defaultMessage="Learn more about passkeys" /></Link>
                                   } 
                              } 
                         />
               </div>
               }
               </>
          :
          <>
               <FieldSkeleton/>
          </>
          }
          </>
     )
}

const BackUpCodeConfig = (props) => {
     var is_backup_code_enabled = props.mfaConfig && props.mfaConfig.hasOwnProperty("backup_codes")
     var backup_code_config = is_backup_code_enabled ? props.mfaConfig.backup_codes : {};
     return (
          <div className="notes">
               <FormattedMessage defaultMessage="We recommend having a backup code in case you need to recover your account" />
          </div>
     );
}

const COPIED_RESET_MS = 3000;

const UserIdField = ({ userId }) => {
     const intl = useIntl();
     const [copied, setCopied] = useState(false);
     const copiedResetTimeoutRef = useRef(null);

     const clearCopiedResetTimeout = useCallback(() => {
          if (copiedResetTimeoutRef.current) {
               clearTimeout(copiedResetTimeoutRef.current);
               copiedResetTimeoutRef.current = null;
          }
     }, []);

     useEffect(() => () => clearCopiedResetTimeout(), [clearCopiedResetTimeout]);

     const handleCopyUserId = useCallback(() => {
          if (!userId || copiedResetTimeoutRef.current) {
               return;
          }

          navigator.clipboard.writeText(userId).then(() => {
               setCopied(true);
               clearCopiedResetTimeout();
               copiedResetTimeoutRef.current = setTimeout(() => {
                    setCopied(false);
                    copiedResetTimeoutRef.current = null;
               }, COPIED_RESET_MS);
          }).catch(() => {
               // Clipboard API may be unavailable; fail silently in UI
          });
     }, [userId, clearCopiedResetTimeout]);

     const copyTooltipLabel = intl.formatMessage({ defaultMessage: "Copy to clipboard" });

     return (
          <div className="uuid-block-holder" data-test-id="uuid-container-block">
               <Typography variant="subtitle2" component="label">
                    <FormattedMessage defaultMessage="User ID" />
               </Typography>
               {userId ? (
                    <Tooltip
                         title={copied ? "" : copyTooltipLabel}
                         placement="top"
                         arrow
                         classes={{ tooltip: "uuid-copy-tooltip", arrow: "uuid-copy-tooltip-arrow" }}
                    >
                         <span className={`uuid-interactive-badge${copied ? " is-copied" : ""}`}>
                              <span className="uuid-string-value">{userId}</span>
                              {copied ? (
                                   <span className="uuid-status-badge">
                                        <CheckIcon className="uuid-success-icon" fontSize="small" aria-hidden="true" />
                                        <span className="uuid-copied-label">
                                             <FormattedMessage defaultMessage="Copied" />
                                        </span>
                                   </span>
                              ) : (
                                   <button
                                        type="button"
                                        className="uuid-copy-button"
                                        onClick={handleCopyUserId}
                                        aria-label={copyTooltipLabel}
                                   >
                                        <FileCopyOutlinedIcon className="uuid-copy-icon" fontSize="small" aria-hidden="true" />
                                   </button>
                              )}
                         </span>
                    </Tooltip>
               ) : null}
          </div>
     );
};

const RecoveryInfo = (props) => {
     return (<>
          <div className="notes">
               <FormattedMessage defaultMessage="We recommend having a backup email in case you need to recover your account" />
          </div>
          {
               props.recoveryEmail && (
                    <Typography variant="subtitle1">
                         {props.recoveryEmail}
                    </Typography>
               )
          }
          <div className="link-holder mtpx-1">
               {
                    props.hasIdentity ? (
                         <>
                              {
                                   props.recoveryEmail ? (
                                        <div className="link" onClick={props.onChangeLinkClick} >
                                             <FormattedMessage defaultMessage="Manage recovery email" />
                                        </div>) : (
                                        <div className="link" onClick={props.onAddLinkClick} >
                                             <FormattedMessage defaultMessage="Add recovery email" />
                                        </div>
                                   )
                              }
                         </>
                    ) : (
                         <FieldSkeleton />
                    )
               }
          </div>
     </>);
}

const AccountDialog = (props) => {
     const [loaded, setLoaded] = useState(false);
     const theme = useTheme();
     const loadHandler = useCallback(() => setLoaded(true), []);
     const closeHandler = useCallback(() => props.onClose(null), [props]);
     const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
     
     useEffect(() => {
          let listener = null;

          if (loaded && !listener) {
               const childWindow = document.getElementById('identity-frame').contentWindow;
               listener = message => {
                    if (message.source !== childWindow) {
                         return; // Skip message in this event listener
                    }

                    if (message.data.status === "complete") {
                         if (props.onClose) {
                              props.onClose(message.data)
                         }
                    }
               };

               window.addEventListener('message', listener, false);
          }

          return () => {
               if (listener) {
                    window.removeEventListener('message', listener, false);
               }
          };
     }, [props, loaded]);

     return (
          <Dialog
               open={props.open}
               TransitionComponent={Transition}
               keepMounted
               onClose={closeHandler}
               aria-labelledby="alert-dialog-slide-title"
               aria-describedby="alert-dialog-slide-description"
               fullWidth={true}
               className="accountFrameDialog"
               fullScreen={fullScreen}
               disableBackdropClick={true}
               disableEscapeKeyDown={true}
          >
               <DialogContent>
                    {/* <span className="popup-cancel-button" onClick={this.closeFrame}>Cancel</span> */}
                    <iframe id="identity-frame" onLoad={loadHandler} src={props.frameUrl} title="Account Link" allow= "publickey-credentials-get; clipboard-read; clipboard-write *"/>
                    
               </DialogContent>
          </Dialog>
     )
}



/**
 * @class Basics
 * @description component contains Account Details
 */
class Accounts extends React.PureComponent {

     /**
      * @function constructor
      * @param {*} props - Having properties passed by parent element
      *  * used for state initialization
      */
     constructor(props) {
          super(props);

          this.state = {
               frameUrl: null
          };

          this.bindedOpenFrame = this.openFrame.bind(this)
     }

     componentDidUpdate(_prevProps, prevState) {
          //     /
     }

     getFrameUrl = (frameUrl,action,data) => {
          let params = {
               username: this.props.preferredUsername || this.props.emails,
               application: this.props.applicationId,
               ui_locales: this.props.locale,
               federation_origin: this.props.federation_origin,
               origin: window.location.origin,
               action: action,
               data: data
          }
          /*For disabling MFA,add a param in iFrame URL if only one MFA method is present to differentiate consent in iFrame*/
          if(action === "disable" && this.props.mfaConfig && this.props.mfaConfig.configured_mfa_settings 
          && Object.keys(this.props.mfaConfig.configured_mfa_settings).length === 1){
               params.one_mfa = "true";
          }
          const queryComponents = Object.keys(params).reduce((agg, val) => {
               if (typeof params[val] === "string" && params[val]?.length > 0) {
                    agg.push(`${val}=${encodeURIComponent(params[val])}`)
               }

               return agg
          }, []);
          return queryComponents.length > 0 ? `${frameUrl}?${queryComponents.join("&")}` : frameUrl;
     }

     openFrame = (frameUrl,action,data) => {
         const encodedUrl = this.getFrameUrl(frameUrl,action,data);
         
          this.setState({
               frameUrl: encodedUrl
          });
     }

     closeFrame = (data) => {
          if (this.props.onChanges) {
               if (data?.multifactor_changed || data?.change_email || data?.change_recovery_email || data?.remove_recovery_email || data?.passkey_changed) {
                    this.props.onChanges();
               } else if (data?.password_changed || data?.account_deleted || data?.change_data_region || data?.policy_changed) {
                    this.props.dispatch({ type: actions.signOut });
               }
          }

          this.setState({ frameUrl: null });
     }
     signOutUser = () => {
          this.props.dispatch({ type: actions.signOut });
     }
     /**
      * @function render
      * @description repaints the component on each change of state and props value
      */
     render() {
          const isEnterpriseFederated = this.props.isEnterpriseFederatedUser;
          let primaryEmail, phoneNumber;
          if(this.props.emails || this.props.preferredUsername) {
               primaryEmail = (
                    <div className="email-holder">
                         <Typography variant="subtitle2" component="label">
                              {isEnterpriseFederated ? (
                                   <>
                                        <FormattedMessage defaultMessage="Email" />
                                        {/* {' ('}
                                        <FormattedMessage defaultMessage="Enterprise SSO" />
                                        {this.props.federation_origin ? ` - ${this.props.federation_origin}` : ''}
                                        {')'} */}
                                   </>
                              ) : this.props.isManagedUser ? (
                                   <FormattedMessage defaultMessage="Username" />
                              ) : (
                                   <FormattedMessage defaultMessage="Email" />
                              )}
                         </Typography>
                         <Typography variant="subtitle1" className="email-value">
                              {this.props.emails || this.props.preferredUsername}
                         </Typography>
                    </div>
               );
          } else {
               primaryEmail = <FieldSkeleton />;
          }
          if (!this.props.phones) {
               phoneNumber = <FieldSkeleton />;

          } else {
               phoneNumber =
                    (
                         <div className="email-holder">
                              <Typography variant="subtitle2" component="label">
                                   <FormattedMessage defaultMessage="SMS Phone Number" />
                              </Typography>
                              <Typography variant="subtitle1">
                                   {
                                        this.props.phones ?? <FormattedMessage defaultMessage="Not Available" />
                                   }
                              </Typography>
                         </div>
                    )
          }
          var show_passkey = flags.show_passkey;
          var show_account_switch = this.props.account_details && this.props.account_details.default_account;
          // Count configured MFA methods (passkeys, authenticator app, secondary email). Alert shows only when exactly one is configured.
          const configuredMfaCount = this.props.mfaConfig && Object.keys(this.props.mfaConfig?.configured_mfa_settings || {})?.length;
          const showSingleMfaAlert = configuredMfaCount === 1;
          return (
               <div className="card accounts">
                     <>
                     <h3>
                         <FormattedMessage defaultMessage="Account Management" />
                    </h3>
                    {showSingleMfaAlert && flags.show_sign_in_and_security && (
                         <div className="single-mfa-alert-wrapper">
                              <Alert
                                   severity="warning"
                                   variant="outlined"
                                   icon={<i className="modus-icons" aria-hidden="true">warning</i>}
                                   className="single-mfa-alert-mui"
                                   role="alert"
                                   aria-label="Your account relies on a single sign-in method. To prevent being locked out, we strongly recommend adding a backup."
                                   data-test-id="single-mfa-alert"
                              >
                                   <FormattedMessage defaultMessage="Don't get locked out. You only have one sign-in method enabled. Add a backup to stay protected." />
                              </Alert>
                         </div>
                    )}
                    {show_account_switch && 
                    <SwitchAccount 
                     hasIdentity={this.props.hasIdentity}
                     uuid={this.props.uuid}
                     endpoints={this.props.endpoints}
                     openFrame={this.openFrame}
                     default_account={this.props.account_details && this.props.account_details.default_account}
                     has_multiple_accounts={this.props.account_details && this.props.account_details.has_multiple_accounts}
                     reload_data = {this.props.onChanges}
                     sign_out = {this.signOutUser}
                    />
                    }
                    </>
                    {(show_account_switch || isEnterpriseFederated) && 
                    <h4>
                         <FormattedMessage defaultMessage="Profile details" />
                    </h4> }
                    <div className="form-holder">
                         
                         <div className="identification-holder">
                              
                              {
                              /* Federated users — admin alert + User ID (no email) */
                              (isEnterpriseFederated) ?
                              (this.props.hasIdentity ?
                              <div className="email-section">
                                   {primaryEmail}
                                   <UserIdField userId={this.props.uuid} />
                              </div>
                              :
                              <FieldSkeleton />)
                              :
                              /* Native, Social and managed users */
                              (this.props.hasIdentity ?
                              <>
                              {(this.props.isTIDUser || this.props.isSocialUser) && <>
                                   <div className="email-section">
                                        {primaryEmail}
                                        <UserIdField userId={this.props.uuid} />
                                        {(this.props.isTIDUser && !this.props.isManagedUser && <div className="link-holder">
                                             <div className="link" onClick={() => { this.openFrame(this.props.endpoints.changeEmail) }}><FormattedMessage defaultMessage="Change email address" /></div>
                                        </div>)}
                                   </div>
                              </>}

                              {this.props.isTIDUser && <>
                                   <div className="link-holder">
                                        <Button className="link custom-button buttonLink custom-button__focus" onClick={() => { this.openFrame(this.props.endpoints.changePassword) }} disableRipple><FormattedMessage defaultMessage="Change password" /></Button>
                                        {!this.props.isManagedUser && <Button className="link custom-button buttonLink custom-button__focus" onClick={() => { this.openFrame(this.props.endpoints.deleteAccount) }} disableRipple><FormattedMessage defaultMessage="Delete your Trimble Identity" /></Button>}
                                   </div>
                              </>}

                              {this.props.isSocialUser && <>
                                   <div className="link-holder">
                                        <Button className="link custom-button buttonLink custom-button__focus" onClick={() => { this.openFrame(this.props.endpoints.deleteSocialAccount) }} disableRipple><FormattedMessage defaultMessage="Delete your Trimble Identity" /></Button>
                                   </div>
                              </>}
                              
                              </>
                              :
                              <FieldSkeleton />
                              )
                              }
                             
                         </div>
                 
                         {flags.show_sign_in_and_security ? (
                              <SignInAndSecurity
                                   emails={this.props.emails || this.props.preferredUsername}
                                   isTIDUser={this.props.isTIDUser}
                                   isSocialUser={this.props.isSocialUser}
                                   isManagedUser={this.props.isManagedUser}
                                   endpoints={this.props.endpoints}
                                   openFrame={this.openFrame}
                                   getFrameUrl={this.getFrameUrl}
                                   passkeyConfig={this.props.passkeyConfig}
                                   mfaConfig={this.props.mfaConfig}
                                   hasIdentity={this.props.hasIdentity}
                                   onChanges={this.props.onChanges}
                              />
                         ) : (
                              <>
                         {show_passkey &&
                         <div className="passkey-holder">
                              <PasskeyConfig
                                   passkeyConfig= {this.props.passkeyConfig}
                                   hasIdentity={this.props.hasIdentity}
                                   endpoints={this.props.endpoints}
                                   getFrameUrl = {this.getFrameUrl}
                                   openFrame={this.openFrame}
                                   />
                         </div>}
                         {(this.props.isTIDUser || (this.props.isSocialUser && this.props.mfaConfig && this.props.mfaConfig.configured_mfa_settings 
                              && Object.keys(this.props.mfaConfig.configured_mfa_settings).length > 0)) && 
                         <div className="mfa-holder">
                              {this.props.isMfaExists ?
                              <>
                                   <h4><FormattedMessage defaultMessage="Multi-Factor Authentication" /><Switch color="primary" onClick={this.showMFAFrame} checked={this.props.isMfaExists} /></h4>
                                   <MFAInfo mfaMethodType={this.props.mfaMethodType} 
                                   isMfaExists={this.props.isMfaExists} 
                                   phoneNumber={phoneNumber}
                                   openFrame={this.openFrame}
                                   endpoints={this.props.endpoints}
                              
                                   />
                              </>
                                   : 
                              <>
                              <MFAConfig
                                   mfaConfig={this.props.mfaConfig}
                                   passkeyConfig={this.props.passkeyConfig}
                                   openFrame={this.openFrame}
                                   getFrameUrl = {this.getFrameUrl}
                                   endpoints={this.props.endpoints}
                                   hasIdentity={this.props.hasIdentity}
                                   saveIdentityDetails={this.props.saveIdentityDetails}
                                   isSocialUser={this.props.isSocialUser}
                                   reset_sms_end_date_crossed={this.props.reset_sms_end_date_crossed}
                                   />
                              </>
                              }
                         
                         </div>}
                              </>
                         )}
                         {/*this.props.isTIDUser && <div className="recovery-holder">
                              <Divider />
                              <h4><FormattedMessage defaultMessage="Recovery Email" /></h4>
                              <RecoveryInfo onChangeLinkClick={() => { this.openFrame(this.props.endpoints.changeRecoveryEmail) }} onAddLinkClick={() => { this.openFrame(this.props.endpoints.addRecoveryEmail) }} recoveryEmail={this.props.recoveryEmail} hasIdentity={this.props.hasIdentity}/>
                    </div>*/}
                         {/* <div className="link-holder">
                              <div className="link" onClick={() => { this.openFrame(process.env.REACT_APP_CHANGE_PASSWORD_LINK) }}>Change SMS phone number</div>

                         </div> */}
                        
                         <AccountDialog frameUrl={this.state.frameUrl} open={(this.state.frameUrl !== null) ? true : false} onClose={this.closeFrame} />
                    </div>
               </div >
          );
     }
     showMFAFrame = () => {
          this.openFrame(this.props.endpoints.disableMFA);
     }
}

/**
 * For mapping necessary state variables to current component properties
 * @param {Object} state - Immutable State Object
 * @return properties needed from state 
 */
const mapStateToProps = (state) => {
     const regionEndpoints = {
          'us': process.env.REACT_APP_US_IDENTITY_ENDPOINT,
          'eu': process.env.REACT_APP_EU_IDENTITY_ENDPOINT,
          'uk': process.env.REACT_APP_UK_IDENTITY_ENDPOINT,
          'eu-gb': process.env.REACT_APP_UK_IDENTITY_ENDPOINT,
          'ap-au': process.env.REACT_APP_AU_IDENTITY_ENDPOINT
     };

     const userRegion = regionEndpoints[state.auth?.profile?.data_region ?? "us"]
     const federation_origin = (state.auth?.profile?.federation_origin) ?? null;
     const is_managed_user = (state.userManager?.identity?.preferred_username) ? true : false;

     return {
          emails: (state.userManager?.identity?.email) ?? null,
          uuid: (state.auth?.profile?.sub) ?? (state.userManager?.identity?.uuid) ?? null,
          phones: (state.userManager?.identity?.phone_number) ?? null,
          isMfaExists: (state.userManager?.identity?.mfa_settings?.length > 0) ? true : false,
          isTIDUser: isTIDUser(state.auth?.profile),
          isEnterpriseFederatedUser: isEnterpriseFederatedUser(state.auth?.profile),
          isManagedUser: is_managed_user,
          preferredUsername: (state.userManager?.identity?.preferred_username) ?? null,
          mfaConfig:  state.userManager?.identity?.mfa_config,
          passkeyConfig: state.userManager?.identity?.passkey_config,
          isSocialUser: isSocialUser(state.auth?.profile),
          mfaMethodType: state.userManager?.identity?.mfa_settings?.[0],
          applicationId: (state.auth?.profile?.azp) ?? null,
          account_details: state.userManager?.identity?.account_details,
          reset_sms_end_date_crossed: state.userManager?.identity?.sms_end_date,
          endpoints: {
               identityAPI: userRegion,
               changeEmail: `${userRegion}/ui/change_email.html`,
               changePassword: `${userRegion}/ui/change_password.html`,
               changeDataRegion: `${userRegion}/ui/change_data_region.html`,
               deleteAccount: `${userRegion}/ui/delete_account.html`,
               enableMFA: `${userRegion}/ui/enable_multifactor.html`,
               disableMFA: `${userRegion}/ui/disable_multifactor.html`,
               changeRecoveryEmail: `${userRegion}/ui/change_recovery_email.html`,
               addRecoveryEmail: `${userRegion}/ui/add_recovery_email.html`,
               deleteSocialAccount: `${userRegion}/ui/delete_social_account.html`,
               enableTotpMfa: `${userRegion}/ui/enable_mfa_totp.html`,
               enableEmailMfa: `${userRegion}/ui/enable_mfa_email.html`,
               enableSmsMfa: `${userRegion}/ui/enable_mfa_sms.html`,
               disableAllMfa: `${userRegion}/ui/disable_mfa_all.html`,
               disableTotpMfa: `${userRegion}/ui/disable_mfa_totp.html`,
               disableSmsMfa: `${userRegion}/ui/disable_mfa_sms.html`,
               disableEmailMfa: `${userRegion}/ui/disable_mfa_email.html`,
               managePasskey: `${userRegion}/ui/manage_passkey.html`,
               createPasskey: `${userRegion}/ui/create_passkey.html`,
               enablePasskeyMfa: `${userRegion}/ui/enable_mfa_passkey.html`,
               disablePasskeyMfa: `${userRegion}/ui/disable_mfa_passkey.html`,
               muCreatePasskey: `${userRegion}/ui/mu_create_passkey.html`,
               muManagePasskey: `${userRegion}/ui/mu_manage_passkey.html`,
               recoveryCodeMfa: `${userRegion}/ui/recovery_code.html`,
               manageRecoveryNumber: `${userRegion}/ui/v2/manage-recovery-phone`,
               renameTotpMfa: `${userRegion}/ui/rename_mfa_totp.html`,
          },
          region: state.auth?.profile?.data_region,
          locale: (state.userManager?.language) ?? null,
          recoveryEmail: (state.userManager?.identity?.recovery_email) ?? null,
          hasIdentity: (state.userManager?.identity) ?? null,
          hasRegion: false,
          federation_origin
     }
};
export default withRouter(connect(mapStateToProps)(Accounts));